import type { IconProps } from '@src/components/icons/IconProps';

export function WarningIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 4l9 16H3L12 4Z" />
      <path d="M12 10v5M12 17.5h.01" />
    </svg>
  );
}
